<template>
  <atop>
    <div class="flex" />
    <div class="menu-hamburger">
      <button class="menu-toggle"
              @click="ToggleHideMenu"
      >
        <span class="material-icons">menu</span>
      </button>
    </div>
  </atop>
  <aside :class="`${isExpanded && 'is-expanded' || isHidden && 'is-hidden'}`">
    <div class="logo">
      <img id="sidebarLogo"
           src="../assets/nordomatic_new.png"
           alt="Vue"
      >
    </div>
    <div class="menu-toggle-wrap">
      <button class="menu-toggle"
              @click="ToggleMenu"
      >
        <span class="material-icons">keyboard_double_arrow_right</span>
      </button>
    </div>
    <div v-if="isAuthenticated"
         class="menu"
    >
      <router-link class="button"
                   to="/dashboard"
                   @click="hideSideBar()"
      >
        <span class="material-icons">dashboard</span>
        <span class="text">{{ $t('sidebar.dashboard') }}</span>
      </router-link>
      <router-link class="button"
                   to="/tasks"
                   @click="hideSideBar()"
      >
        <span class="material-icons">task</span>
        <span class="text">{{ $t('sidebar.task') }}</span>
      </router-link>
      <router-link class="button"
                   to="/objects"
                   @click="hideSideBar()"
      >
        <span class="material-icons">apartment</span>
        <span class="text">{{ $t('sidebar.object') }}</span>
      </router-link>
      <router-link class="button"
                   to="/messages"
                   @click="hideSideBar()"
      >
        <div class="message-icon-wrapper">
          <span class="material-icons">message</span>
          <span v-if="unreadTaskCount >= 0"
                :class="{ 'unread-count': true, 'large': unreadTaskCount >= 10 }"
          >{{ unreadTaskCount }}</span>
        </div>
        <span class="text">{{ $t('sidebar.message') }}</span>
      </router-link>
    </div>
    <div class="flex" />
    <div v-if="!isAuthenticated"
         class="menu"
    >
      <router-link class="button"
                   to="/login"
                   @click="hideSideBar()"
      >
        <span class="material-icons">login</span>
        <span class="text">{{ $t('sidebar.login') }}</span>
      </router-link>
    </div>
    <div v-if="isAuthenticated"
         class="menu"
    >
      <router-link class="button"
                   to="/account"
                   @click="hideSideBar()"
      >
        <span class="material-icons">person</span>
        <span class="text">{{ $t('sidebar.profile') }}</span>
      </router-link>
      <a href="#"
         class="button"
         @click="handleLogoutSubmit"
      >
        <span class="material-icons">logout</span>
        <span class="text">{{ $t('sidebar.logout') }}</span>
      </a>
    </div>
    <div>
      <LanguageChoice />
    </div>
  </aside>
</template>

<script setup>

import LanguageChoice from '../components/subcomponents/LanguageChoice.vue'
import { onMounted, onUnmounted, computed, ref } from 'vue'
import { useStore } from 'vuex'
import { clearSessionStorage } from '@/utils/preferences.js'
const store = useStore()

const isAuthenticated = computed(() => store.state.sidebar.isAuthenticated)
const isExpanded = computed(() => store.state.sidebar.isExpanded)
const isHidden = computed(() => store.state.sidebar.isHidden)

onMounted(async () => {
  if (localStorage.getItem('token')) {
    store.commit('sidebar/setAuth') // Already logged in, make sure we set state to logged in.
  }
  // store.dispatch('message/getBaseData')
  windowWidth.value = window.innerWidth
  window.addEventListener('resize', myEventHandler)
})

const windowWidth = ref(1000)

onUnmounted(async () => {
  window.removeEventListener('resize', myEventHandler)
  // store.dispatch('message/getBaseData')
})
const unreadTaskCount = computed(() => store.state.message.unreadTaskCount)
function myEventHandler (e) {
  windowWidth.value = window.innerWidth
  if (windowWidth.value < 768) {
    store.commit('sidebar/setIsExpanded', false)
    store.commit('sidebar/setIsHidden', true)
  }
}

function ToggleMenu () {
  if (windowWidth.value < 768) {
    store.commit('sidebar/setIsHidden', true)
  }
  store.commit('sidebar/toggleIsExpanded')
}

function ToggleHideMenu () {
  store.commit('sidebar/toggleIsHidden')
  store.commit('sidebar/setIsExpanded', true)
  if (isHidden.value === true) {
    store.commit('sidebar/setIsExpanded', false)
  }
}

function hideSideBar () {
  if (isHidden.value !== true) {
    store.commit('sidebar/toggleIsHidden')
    store.commit('sidebar/setIsExpanded', false)
  }
}
function handleLogoutSubmit () {
  clearSessionStorage()
  store.commit('sidebar/sidebarLogOut')
  window.location.href = '/login'
}
</script>

<style lang="scss" scoped>
atop {
    top:0px;
    height: calc(2rem + 32px);
    min-width: 100%;
    padding: 1rem;

    z-index: 95;
    background-color: var(--mainBlue);
    color: var(--mainLightBlue);

    transition: 0.2s ease-out;

    .flex {
        flex: 1 1 0;
    }

    .menu-hamburger {
        display: flex;
        justify-content: flex-end;
        margin-bottom: 0rem;

        position: relative;
        top: 0;
        transition: 0.2s ease-out;
        opacity: 1;
        .menu-toggle {
            transition: 0.2s ease-out;

            .material-icons {
                font-size: 2rem;
                color: var(--mainLightBlue);
            }

            &:hover {
                .material-icons {
                    font-size: 2rem;
                    color: var(--mainBlue);
                    transition: 0.2s ease-out;
                }
            }
        }
    }

    .pageHeaderText{
        display: inline;
        margin-left: 23px;
        top: 25px;
        position: fixed;
        font-size: 17px;
    }

    @media(min-width:768px) {
      transition: 0.2s ease-out;
      top:-100px;
      position: fixed;
      z-index: 95;
      .pageHeaderText{
        display: none;
     }
  }
}

aside {
    display: flex;
    flex-direction: column;
    width: calc(2rem + 32px);
    overflow: hidden;
    min-height: 100vh;
    padding: 1rem 1rem 0rem 1rem;
    left:0px;
    background-color: var(--mainBlue);
    color: var(--mainLightBlue);

    z-index: 99;
    transition: 0.2s ease-out;

    .flex {
        flex: 1 1 0;
    }
    .versionText{
        margin-left: 4px;
        font-size: 11px;
    }
    .logo {
        margin-bottom: 1rem;

        img {
            width: 2rem;
            transition: 0.2s ease-out;
        }
    }

    .menu-toggle-wrap {
        display: flex;
        justify-content: flex-end;
        margin-bottom: 0rem;

        position: relative;
        top: 0;
        transition: 0.2s ease-out;

        .menu-toggle {
            transition: 0.2s ease-out;

            .material-icons {
                font-size: 2rem;
                color: var(--mainLightBlue);
            }

            &:hover {
                .material-icons {
                    font-size: 2rem;
                    color: var(--mainBlue);
                    transition: 0.2s ease-out;
                }
            }
        }
    }

    h3,
    .button .text {
        opacity: 0;
        transition: 0.3s ease-out;
    }
    .textButton {
        opacity: 0;
        transition: 0.3s ease-out;
    }

    .menu {
        margin: 0 -1rem;
        z-index: 1;
        .button {
            width: 100%;
            display: flex;
            align-items: center;
            text-decoration: none;
            padding: 0.4rem 1rem;

            transition: 0.2s ease-out;

            .material-icons {
                font-size: 2rem;
                color: var(--mainLightBlue);
                transition: 0.2s ease-out;
            }

            .text {
                color: var(--mainLightBlue);
                transition: 0.2s ease-out;
            }
            .textButton {
                font-size: 1rem;
                color: #ffffff;
                transition: 0.2s ease-out;
            }

            &:hover,
            &.router-link-exact-active {
                background-color: white;

                .material-icons,
                .text {
                    color: var(--mainMediumBlue);
                }
                .textButton {
                    color: var(--mainBlue);
                }
            }

            &.router-link-exact-active {
                border-right: 5px solid var(--mainBlue);
            }

        }
    }

    &.is-expanded {
        width: 250px;

        transition: 0.2s ease-out;
        @media(max-width:768px) {
          width: 100%;
        }
        .menu-toggle-wrap {
            top: -3rem;

            .menu-toggle {
                transform: rotate(-180deg);
            }
        }

        h3,
        .button .text {
            opacity: 1;
        }

        .textButton {
            opacity: 1;
        }

        .button {
            .material-icons {
                margin-right: 1rem;
            }
        }

        .logo {
            margin-bottom: 1rem;

            img {
                width: 3.5rem;
                transition: 0.2s ease-out;
            }
        }
.unread-count {
  right: 7px;
}
}

    &.is-hidden{

        left:0px;
        transition: 0.4s ease-out;

        @media(max-width:768px) {
            transition: 0.4s ease-out;
            position: fixed;
            z-index: 99;
            left:-250px;
        }
    }

 @media(max-width:768px) {
            transition: 0.4s ease-out;
            position: fixed;
            z-index: 99;
            left:0px;
}
.message-icon-wrapper {
  position: relative;
  display: inline-block;
}

.message-icon-wrapper .material-icons {
  font-size: 2rem;
  color: var(--mainLightBlue);
}

.unread-count {
  position: absolute;
  top: -6px;
  right: -7px;
  background-color: red;
  color: white;
  border-radius: 50%;
  padding: 3px 7px;
  font-size: 0.75rem;
  font-weight: bold;
}

.unread-count.large {
  padding: 3px 4px;
  font-size: 0.7rem;
}

}

</style>
